import { createReducer } from '@reduxjs/toolkit';

import type { ConversaoDaNotificacaoState } from '../../types/conversao.types';
import { consultarConversao, limparConsultaDaConversao } from './actions';
import { MENSAGEM_DE_FALHA_DA_CONVERSAO, STATUS_FORA_DO_CONTRATO } from './services';

const estadoInicial: ConversaoDaNotificacaoState = {
  itemId: null,
  consultaId: null,
  carregando: false,
  erro: null,
  resultado: null,
};

const consultaAtual = (
  state: ConversaoDaNotificacaoState,
  meta: { arg: string; requestId: string },
): boolean => state.itemId === meta.arg && state.consultaId === meta.requestId;

export const conversaoDaNotificacaoReducer = createReducer(estadoInicial, (builder) => {
  builder
    .addCase(consultarConversao.pending, (state, { meta }) => {
      // Outro item começa do zero: o resultado anterior é de outra notificação e não pode aparecer
      // nem por um instante. No mesmo item, o último resultado fica até o novo chegar.
      const resultado = state.itemId === meta.arg ? state.resultado : null;
      return {
        ...estadoInicial,
        itemId: meta.arg,
        consultaId: meta.requestId,
        carregando: true,
        resultado,
      };
    })
    .addCase(consultarConversao.fulfilled, (state, { payload, meta }) => {
      if (!consultaAtual(state, meta)) return;
      state.carregando = false;
      state.erro = null;
      // Substitui inteiro: a origem identificada depois troca o aviso, sem mesclar com a anterior.
      state.resultado = payload;
    })
    .addCase(consultarConversao.rejected, (state, { payload, meta }) => {
      if (!consultaAtual(state, meta)) return;
      state.carregando = false;
      if (meta.aborted) return;
      state.resultado = null;
      state.erro = payload ?? {
        status: STATUS_FORA_DO_CONTRATO,
        mensagem: MENSAGEM_DE_FALHA_DA_CONVERSAO,
      };
    })
    .addCase(limparConsultaDaConversao, (state, { payload }) =>
      state.itemId === payload ? estadoInicial : state,
    );
});
